import { ReactElement } from "react";

import { centsToDollarsDisplay } from "../../common/helpers/stringUtils";
import Condition from "../../components/Conditional/Condition";
import I18nText from "../../components/I18nText/I18nText";
import OrderConfirmationCustomizations from "./OrderConfirmationCustomizations";

interface IProps {
	setItem: any; // Using any since the API type is not well defined
}

const OrderConfirmationSetItem = ({ setItem }: IProps): ReactElement => {
	const hasCustomizations = setItem.food_supplier_customization?.length > 0;
	const hasPriceDiff = setItem.price_diff && setItem.price_diff > 0;

	return (
		<li className="SetItem">
			<div className="Item">
				<I18nText
					className="ItemTitle"
					enText={setItem.title_en || setItem.title}
					cnText={setItem.title_cn}
				/>
				<Condition check={hasPriceDiff}>
					<span className="ItemPrice">{`+ $${centsToDollarsDisplay(setItem.price_diff)}`}</span>
				</Condition>
			</div>
			<Condition check={hasCustomizations}>
				<OrderConfirmationCustomizations customizations={setItem.food_supplier_customization} />
			</Condition>
		</li>
	);
};

export default OrderConfirmationSetItem;
